__webpack_require__.p = "https://laser.forsspa.com/";